// extracted by mini-css-extract-plugin
module.exports = {"collapse":"index_collapse__GQXG1"};